

































import { PosVehicleState, POS_FILTER_TYPE, PosFilter } from 'gl-ms-positions';
import { NTR_FILTER_TYPE } from 'gl-ms-notifier';
import { ACTION_SET_NOTIFIER_FILTER, GET_ALL_NOTIFICATIONS } from '@/store/modules/notifier';

export default {
    data() {
        return {
            textModel: '',
            selectModel: [],
            fromToDateModel: [],
        };
    },
    props: ['filter', 'filterKey'],
    computed: {
        isSelect(this: any) {
            return this.currentFilter.type === NTR_FILTER_TYPE.SELECT;
        },
        isText(this: any) {
            return this.currentFilter.type === NTR_FILTER_TYPE.TEXT;
        },
        isDateRange(this: any) {
            return this.currentFilter.type === NTR_FILTER_TYPE.DATE_RANGE;
        },
        key(this: any) {
            return this.currentFilter.key;
        },
        currentFilter(this: any) {
            return this.$store.state.notifier.filters.find((item: PosFilter) => item.key === this.filterKey);
        },
        options(this: any) {
            if (this.isSelect) {
                return this.currentFilter.items;
            }

            return [];
        },
        placeholder(this: any) {
            return this.$t(`notifierFilter.${this.key}`);
        },

        isDisabled(this: any) {
            return !this.currentFilter.enabled;
        },
    },
    components: {
    },
    watch: {
        currentFilter(this:any) {
            this.updateSelected();
        },
    },
    methods: {
        update(this: any) {
            let values;
            if (this.isSelect) {
                values = this.selectModel;
            } else if (this.isDateRange) {
                values = this.fromToDateModel.map((el: any) => new Date(el).toISOString());
            } else {
                values = this.textModel;
            }
            this.$store.commit(ACTION_SET_NOTIFIER_FILTER, { key: this.key, values });
            this.$store.dispatch(GET_ALL_NOTIFICATIONS, true);
        },
        updateSelected(this: any) {
            if (this.currentFilter) {
                if (this.isSelect) {
                    this.selectModel = this.currentFilter.selected;
                }

                if (this.isText) {
                    this.textModel = this.currentFilter.selected;
                }

                if (this.isDateRange) {
                    this.fromToDateModel = this.currentFilter.selected;
                }
            }
        },
    },

    mounted(this: any) {
        this.updateSelected();
    },
};
